import { ElementKind, sectionTypes } from './enums'
import getAllAssessments from './getAllAssessments'
import getAllWidgetElements from './getAllWidgetElements'
import { ObjectState, RecommendationFragmentType, SectionData, WidgetData } from './types'

const getAvailableTags = (sections: SectionData[]) => {
  const conditionalTags: Record<number, string> = {}

  const relevantAssessments = getAllAssessments(sections)
  const relevantWidgets = getAllWidgetElements(sections)

  const relevantFragments = sections.flatMap<any>(sec => {
    if (sec.type === sectionTypes.CONTENT) {
      return sec.elements?.flatMap(el => {
        if (el.kind === ElementKind.RECOMMENDATION) {
          return el as RecommendationFragmentType
        }

        return []
      })
    }

    return []
  }) as RecommendationFragmentType[]

  const fragmentsTags = relevantFragments.flatMap(el => {
    const widgetTags = el.widgets?.flatMap(getTagsFromWidget)

    return (widgetTags?.length ? [...widgetTags, ...(el.setTags || [])] : el.setTags) || []
  })

  const assessmentTags = relevantAssessments.flatMap(el => {
    return el.responses.flatMap((r: any) => r.tags || [])
  })

  const widgetTags = relevantWidgets.flatMap(el => {
    const widgetElement = el as WidgetData
    return getTagsFromWidget(widgetElement)
  })

  const tags = [...assessmentTags, ...widgetTags, ...fragmentsTags]

  tags.forEach(tag => {
    conditionalTags[tag.id] = tag.name
  })

  return conditionalTags
}

function getTagsFromWidget(w: WidgetData) {
  const tagsFromStates = w.states?.flatMap((s: ObjectState) => s.activeTags || []) || []
  const res = [...tagsFromStates, ...(w.setTags || [])]

  return res
}

export default getAvailableTags
